import { PropsWithChildren } from 'react'
import { Redirect, Stack } from 'expo-router'
import { useStore } from '../../app/models'
import { observer } from 'mobx-react-lite'
import { LoaderScreen } from '../../app/components/LoaderScreen/LoaderScreen'

import { useRouter } from 'expo-router'
import { View } from 'react-native'
import { DS } from '../../app/design-system'
import { useSessionStore } from '@/models/session/useSessionStore'
import { shouldBlockUiForMeLoad } from '@/models/session/me-loading-gate'
import { ConvexProvider } from '@/providers/ConvexProvider'
import { useIsAdmin } from '@/hooks/useUserRoles'

const AdminStack = observer(() => {
  const store = useStore()
  const router = useRouter()
  const isLoggedIn = useSessionStore((state) => state.tokenConfig?.accessToken !== undefined)
  const isAdmin = useIsAdmin()

  if (shouldBlockUiForMeLoad({ isLoggedIn, isMeLoading: store.session.isMeLoading, hasUser: !!store.session.user })) {
    return <LoaderScreen />
  }

  if (!isAdmin) {
    return <Redirect href={'/'} />
  }

  return (
    <Stack screenOptions={{ contentStyle: { backgroundColor: DS.palette['Brand/Cream'] } }}>
      <Stack.Screen
        name="dashboard"
        options={{
          headerShown: false
        }}
      />
      <Stack.Screen
        name="dashboard/users/[userId]"
        options={{
          headerShown: false
        }}
      />
      <Stack.Screen
        name="reports"
        options={{
          headerShown: false
        }}
      />
      <Stack.Screen
        name="dashboard/lounges/[loungeId]"
        options={{
          headerShown: false
        }}
      />
      <Stack.Screen
        name="dashboard/lounges/[loungeId]/report"
        options={{
          headerShown: false
        }}
      />
    </Stack>
  )
})

export default function AdminLayout({ children }: PropsWithChildren) {
  return (
    <ConvexProvider>
      <View style={{ backgroundColor: DS.palette['Brand/Cream'], padding: 16, height: '100%' }} id="adminLayout">
        <AdminStack />
        {children}
      </View>
    </ConvexProvider>
  )
}
